import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import "./additional-field.scss"

function CheckboxField({ fieldInfo, parentIndex, entityID, CustomFieldID, fieldResponseKey, multiFormIndex, answerContext, borderColor }) {
    const { register, setValue } = useFormContext();

    useEffect(() => {
        if (entityID) {
            setValue(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.entity_id`, entityID);
        }
    }, [entityID]);

    useEffect(() => {
        if (CustomFieldID) {
            setValue(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.custom_field_id`, CustomFieldID);
        }
    }, [CustomFieldID]);

    useEffect(() => {
        if (fieldResponseKey) {
            setValue(`${fieldResponseKey}.${parentIndex}.answers.${0}.answer_context`, answerContext);
        }
    }, [fieldResponseKey])

    return (
        <>   
            <label className="d-flex align-items-center mt-2 " style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        lineHeight: '1.4',
                        color: '#555',
                        gap: '8px'           
                    }}>
                <input {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.boolean_value`)} className="  recurring-form-check " type="checkbox" 
                 style={{'--checkbox-color': borderColor || "#155C4E", marginTop: '-3px'}}
                />
                {fieldInfo?.field_label}</label>
            {
                fieldInfo?.field_description ?
                    <p className='cf-hint'>{fieldInfo?.field_description}</p> : ''
            }
            
            {
                CustomFieldID ?
                    <input type='hidden' {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.custom_field_id`, {
                        value: CustomFieldID
                    })} /> : ''
            }
            {
                entityID ?
                    <input type='hidden' {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.entity_id`, {
                        value: entityID
                    })} /> : ''
            }
        </>
    );
}

export default CheckboxField;